var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.noData)?_c('div',{ref:"chartContainer",attrs:{"id":_vm.idChart}}):_c('NoData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }